import { render, staticRenderFns } from "./anchor-data.vue?vue&type=template&id=dbba401c&scoped=true"
import script from "./anchor-data.vue?vue&type=script&lang=js"
export * from "./anchor-data.vue?vue&type=script&lang=js"
import style0 from "./anchor-data.vue?vue&type=style&index=0&id=dbba401c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbba401c",
  null
  
)

export default component.exports